// extracted by mini-css-extract-plugin
export var contrastLow = "_2x-1";
export var externalLink = "_2x-2";
export var externalLinkIcon = "_2x-3";
export var link = "_2x-0";
export var linkLabel = "_2x-4";